import React from "react";
import GamesMenuContainer from "../GamesMenu/GamesMenuContainer";
import AdminMenuContainer from "../AdminMenu/AdminMenuContainer";
import {FormattedMessage} from "react-intl";
import { IsMobileContext } from "../isMobileContext";

class RankingRedirectPage extends React.PureComponent {
    static contextType = IsMobileContext;
    render() {
        return <div className="my-results">
            {!this.context.isMobile ? (<div className="my-results__col-left">
                <GamesMenuContainer/>
                <AdminMenuContainer game={this.props.current}/>
            </div>) : null }
            <div className="my-results__col-middle">
                <div className="alert alert-warning">
                    <FormattedMessage
                        id="ranking.redirect"
                        values={{
                            clickHere: <a
                                className="btn btn-warning btn-sm"
                                target="_blank"
                                rel="noopener noreferrer"
                                href={this.props.redirectUrl}>
                                <FormattedMessage id="app.clickHere"/>
                            </a>
                        }}>
                    </FormattedMessage>
                </div>
            </div>
        </div>;
    }
}

export default RankingRedirectPage